/**
 * @file Sms.jsx
 * @description text message icon.
 * @exports Sms
 */
import React from 'react'
const defaultColor = '#284047'

const defaultStyle = {
  fill: defaultColor,
  stroke: 'white',
  strokeWidth: '5px',
}

const Sms = ({ style }) => (
  <svg
    id='comment-bubble'
    viewBox='0 0 75 75'
  >
    <description>text message icon</description>
    <title>text message</title>
    <g
      style={{
        transform: 'translate(12px, 11px) scale(0.3)',
      }}
    >
      <path
        style={{ ...defaultStyle, ...style }}
        d='m 17.4,156 c 4,7.4 21.5,2.6 29.4,-0.2 C 54.8,153 64.5,143.7 64.5,143.7 c 0,0 25.3,4 51,-3.6 25.8,-7.6 50.5,-34.3 49.6,-65.9 C 164.3,42.2 131,3.6 79.7,6.5 28.5,9.4 0.7,44.7 0,78.2 c -0.7,33.5 31.3,52.6 31.3,52.6 0,0 3.2,1.8 4.2,3.6 1,1.9 -3.3,8.4 -3.3,8.4 0.7,0.4 -6.4,8.8 -14.8,11.6z'
      />
      <circle cx='50' cy='76.4' r='9' style={{ fill: 'white' }} />
      <circle cx='84.4' cy='77.1' r='9' style={{ fill: 'white' }} />
      <circle cx='120.2' cy='76.8' r='9' style={{ fill: 'white' }} />
    </g>
  </svg>
)

export default Sms
